export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6811.6fbf2189.jpg";